import { grid } from "styled-system";
import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  ${grid}
`;
